function collectionSpinner() {
  if (window.themeVariables.settings.pageType !== 'collection') return;

  const container = document.querySelector('.shopify-section--main-collection');
  if (!container) return;

  document.addEventListener("theme:loading:start", function() {
    container.classList.add('collection-loading')
  });
  document.addEventListener("theme:loading:end", function(){
    container.classList.remove('collection-loading')
  });
}

window.addEventListener('load', function() {
  collectionSpinner()
})

window.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const value = parseInt(cents, 10);
  if (isNaN(value)) return '';

  const moneyFormat = format || window.themeVariables.settings.moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number === null) return 0;

    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split('.');
    const integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const fraction = parts[1] || '';

    return fraction ? `${integer}${decimal}${fraction}` : integer;
  }

  return moneyFormat
    .replace(/\{\{\s*amount\s*\}\}/, formatWithDelimiters(value, 2))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, formatWithDelimiters(value, 0))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatWithDelimiters(value, 2, '.', ','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, formatWithDelimiters(value, 0, '.', ','))
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, formatWithDelimiters(value, 2, "'", '.'));
}
